import { formatBRL, formatDateBR, formatDateTimeBR as formatDateTimeShared } from "~/shared/ui/format";

export const formatIsoDateBR = (iso) => formatDateBR(iso, "");

export const formatDateTimeBR = (value) => formatDateTimeShared(value, "");

export const joinIdsPt = (ids) => {
  const tags = ids.map((id) => `#${id}`);
  if (tags.length <= 1) return tags.join("");
  return `${tags.slice(0, -1).join(", ")} e ${tags[tags.length - 1]}`;
};

export const plural = (n, singular, pluralForm) => `${n} ${n === 1 ? singular : pluralForm}`;

export const brl = (value) => formatBRL(Number(value || 0));
